import { LatLng, Location, Marshaller } from '../types/core'

const marshaller: Marshaller<LatLng, Location> = {
  marshal: ({ lat: latitude, lng: longitude }) => ({ latitude, longitude }),
  unmarshal: ({ latitude: lat, longitude: lng }) => ({ lat, lng }),
}

export default marshaller
